import { render, staticRenderFns } from "./DocumentEvidences.vue?vue&type=template&id=475693e3&scoped=true&"
import script from "./DocumentEvidences.vue?vue&type=script&lang=ts&"
export * from "./DocumentEvidences.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEvidences.vue?vue&type=style&index=0&id=475693e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475693e3",
  null
  
)

export default component.exports